import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';

//components
import Berita from '../../components/Media/TableBerita';
import Slider from '../../components/Media/CardSlider';

export default class Landing extends Component {
	state = {
		media: 'berita',
	};

	gantiMedia = (e) => {
		this.setState({
			media: e,
			loading: true,
		});
	};

	render() {
		let Media = '';
		if (this.state.media === 'berita') {
			Media = <Berita />;
		}
		if (this.state.media === 'slider') {
			Media = <Slider />;
		}
		return (
			<>
				<section className="section pb-3 pt-0 bg-gradient-warning">
					<Container>
						<Row className="row-grid align-items-center">
							<Col className="order-lg-2 ml-lg-auto pt-5" md="3">
								<div className="position-relative pl-md-5">
									<img
										alt="..."
										className="img-center img-fluid"
										src={require('assets/img/ill/media.png')}
									/>
								</div>
							</Col>
							<Col className="order-lg-1" lg="6">
								<div className="d-flex px-3">
									<div>
										<div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary">
											<i className="fa fa-pencil text-primary" />
										</div>
									</div>
									<div className="pl-4">
										<h5 className="display-4 text-white">Manajemen Media</h5>
										<p className="text-white">Halaman Inputan Suara Masuk</p>
									</div>
								</div>
							</Col>
						</Row>
					</Container>
				</section>

				{/* <section className="section bg-gradient-success">
					<Container>
						<Row>
							<Col lg={3} xs={6}>
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										justifyContent: 'center',
										alignItems: 'center',
										backgroundColor: 'rgba(87, 95, 207,1)',
										padding: '20px',
										cursor: 'pointer',
										marginBottom: '10px',
									}}
									onClick={() => {
										this.gantiMedia('berita');
									}}
								>
									<div>
										<img
											alt="..."
											className="img-center img-fluid"
											src={require('assets/img/ill/newspaper.png')}
										/>
									</div>
									<small className="text-white text-center text-uppercase">Manajemen Berita</small>
								</div>
							</Col>
							<Col lg={3} xs={6}>
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										justifyContent: 'center',
										alignItems: 'center',
										backgroundColor: 'rgba(87, 95, 207,1)',
										padding: '20px',
										cursor: 'pointer',
										marginBottom: '10px',
									}}
								>
									<div>
										<img
											alt="..."
											className="img-center img-fluid"
											src={require('assets/img/ill/calendar.png')}
										/>
									</div>
									<small className="text-white text-center text-uppercase">Manajemen Agenda</small>
								</div>
							</Col>
							<Col lg={3} xs={6}>
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										justifyContent: 'center',
										alignItems: 'center',
										backgroundColor: 'rgba(87, 95, 207,1)',
										padding: '20px',
										cursor: 'pointer',
										marginBottom: '10px',
									}}
									onClick={() => {
										this.gantiMedia('slider');
									}}
								>
									<div>
										<img
											alt="..."
											className="img-center img-fluid"
											src={require('assets/img/ill/slider.png')}
										/>
									</div>
									<small className="text-white text-center text-uppercase">Manajemen Slider</small>
								</div>
							</Col>
							<Col lg={3} xs={6}>
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										justifyContent: 'center',
										alignItems: 'center',
										backgroundColor: 'rgba(87, 95, 207,1)',
										padding: '20px',
										cursor: 'pointer',
										marginBottom: '10px',
									}}
								>
									<div>
										<img
											alt="..."
											className="img-center img-fluid"
											src={require('assets/img/ill/gallery.png')}
										/>
									</div>
									<small className="text-white text-center text-uppercase">Manajemen Gallery</small>
								</div>
							</Col>
						</Row>
					</Container>
				</section> */}
				<section className="section bg-gradient-info">{Media}</section>
			</>
		);
	}
}
